const SeatsPopover = ({
  filter,
  map,
}) => ({
  order: Infinity,
  run($$) {
    filter = filter || R.T;
    map = map || R.identity;

    const $popover = $("<div class=\"tc-section--popover\" />")
      .css({
        position: "absolute",
        padding: "5px 8px",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        border: "1px solid rgba(230, 230, 230, 1)",
        borderLeftWidth: "6px",
        borderRadius: "4px",
        zIndex: 3,
      })
      .hide()
      .appendTo("body");

    const hoverHandler = (event) => {
      const $seat = $(event.target);
      const seat = $$.getSeat($seat.data("row"), $seat.data("coll"));
      if (!filter(seat)) {
        return;
      }
      if (event.type === "mouseenter") {
        $popover.show().html(map(seat));

        $popover.css({
          top: $seat.offset().top - $popover.outerHeight(),
          left: $seat.offset().left,
        });
      } else {
        $popover.hide();
      }
    };

    $$.$arena.on("mouseenter mouseleave", ".seats-container > div", hoverHandler);
  },

  destroy($$) {
    $("body").remove(".tc-section--popover");
    $$.$arena.off("mouseenter mouseleave", ".seats-container > div", hoverHandler);
  },
});

window.SectionSeatsPopover = SeatsPopover;

export default SeatsPopover;
